import React, { useState } from 'react'
import {
  Card,
  CardContent,
  Typography,
  Button,
  CardHeader,
  Chip
} from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import { green } from '@material-ui/core/colors';

function ExtraResource({ resource, onChange }) {
  const { t } = useTranslation()
  const [selected, setSelected] = useState(false)

  const updateSelected = (value) => {
    onChange(resource.key, !selected ? value : null)
    setSelected(!selected)
  }

  if (resource.courts && resource.courts.length > 0) {
    const res = resource.courts[0]
    const time = res.times ? res.times[0] : null
    const { displayName, start, id } = res
    const { price, duration } = time || {}
    const selectionStyle = selected ? { background: 'white', borderColor: '#9ecaed', boxShadow: 'inset 0 0 10px #9ecaed' } : {}
    return (
      <Card
        className={'mb-2'}
        key={id}
        style={{...selectionStyle, cursor: 'pointer' , padding: 0 }}
      >
          <CardHeader
          action={selected ? <CheckCircleOutlineIcon  style={{ color: green[500] }} /> : <RadioButtonUncheckedIcon color='action' />}
          title={displayName}
          disableTypography={true}
          style={{ paddingBottom: 0 }}
          />
        <CardContent
          onClick={() =>
            updateSelected({ start: start, duration: duration, resourceId: id })
          }
          style={{ cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center', paddingBottom: 5, paddingTop: 10 }}
        >
          <Typography variant='body2' className={'p-0'}>
            <Chip label={price ? price.toFixed(2).replace('.', ',') + ' €' : null} style={{ backgroundColor: green[500], color: 'white' }} size='small' />
          </Typography>
          <Button
            onClick={() =>
              updateSelected({
                start: start,
                duration: duration,
                resourceId: id,
              })
            }
            color={selected ? 'danger' : 'primary'}
            size={'small'}
          >
            {selected ? t('remove') : t('add')}
          </Button>
        </CardContent>
      </Card>
    )

    // return (
    //   <Row className={'loose'} key={'payment'}>
    //     <Col>
    //       <Button
    //         onClick={() =>
    //           updateSelected({
    //             start: start,
    //             duration: duration,
    //             resourceId: id,
    //           })
    //         }
    //         color={'primary'}
    //         size={'sm'}
    //         outline={!selected}
    //       >

    //         {displayName} <Badge color='success' pill>{price ? (price).toFixed(2).replace('.', ',') + ' €' : null}</Badge>
    //       </Button>
    //     </Col>
    //   </Row>
    // )
  } else {
    return null
  }
}

export default ExtraResource
